import { render, staticRenderFns } from "./sfc-dfp-ad.vue?vue&type=template&id=08bf1ea0&"
import script from "./sfc-dfp-ad.vue?vue&type=script&lang=js&"
export * from "./sfc-dfp-ad.vue?vue&type=script&lang=js&"
import style0 from "./sfc-dfp-ad.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports